import React from 'react';

const MainLayout = props => <div> {props.children} </div>;

export default MainLayout;